import {useTranslation} from "react-i18next";
import Modal from "../../../common/modal/Modal";
import {PersonTranslKey} from "../PersonTranslKey";
import {PersonActionPanel} from "./PersonActionlPanel";
import {useClientLocator} from "../../../client/ApiClientLocator";
import {PersonInfoPanel} from "./PersonInfolPanel";
import {SubmissionTranslKey} from "../../submission/SubmissionTranslKey";
import UserRoleResolver from "../../user/UserRoleResolver";
import {useUserRoles} from "../../user/UserContext";
import TabNav from "../../../common/tab/TabNav";
import {useDefaultQuery} from "../../../client/useDefaultQuery";

export interface PersonDetailDialogProps {
    personId: number;
    reloadPersonGrid: () => void;
    open: boolean;
    onClose: (updated: boolean) => void;
}

export default function PersonDetailPanel(props: Readonly<PersonDetailDialogProps>) {
    const {personId, reloadPersonGrid, open, onClose} = props;
    const {t} = useTranslation();
    const {personClient} = useClientLocator();

    const roles = useUserRoles();
    const isAdministrator = UserRoleResolver.isAdministrator(roles);

    const {data: person, refetch} = useDefaultQuery({
        queryKey: ["person", personId],
        staleTime: 5 * 60 * 1000,
        queryFn: () => personClient.findById(personId),
    });

    const personInfoTab = {
        label: t(SubmissionTranslKey.DOCUMENTS),
        content: <>
            {person && <PersonInfoPanel person={person} />}
        </>,
    };

    const personInfoAndActionTab = {
        label: t(PersonTranslKey.PERSON_DETAIL),
        content: (
            <>
                {person && <PersonInfoPanel person={person} />}

                {person && <PersonActionPanel person={person}
                                              reloadPersonDetail={refetch}
                                              reloadPersonGrid={reloadPersonGrid} />
                }
            </>
        ),
    };

    const tabItems = isAdministrator ? [personInfoAndActionTab] : [personInfoTab];

    return (
        <Modal
            open={open}
            label={t(PersonTranslKey.PERSON_DETAIL)}
            iconProps={{type: "complex", name: "doc-filled"}}
            maxWidth={"60rem"}
            onClose={() => onClose(false)}
        >
            <TabNav items={tabItems} />
        </Modal>
    );
}
